import { gql } from '@apollo/client';
import { GridItem, Stack } from '@chakra-ui/react';
import { DisplayLockingSection_DisplayFragment } from '~components/displays/DisplayDetail/locking/__generated__/DisplayLockingSection.graphql';
import { useFeatureFlag } from '~utils/features';
import { DisplayInfraRedControlToggle } from './DisplayInfraRedControlToggle';
import { DisplayKeyboardControlToggle } from './DisplayKeyboardControlToggle';
import { DisplayPortsControlToggle } from './DisplayPortsControlToggle';

interface Props {
  display: DisplayLockingSection_DisplayFragment;
}

export function DisplayLockingSection({ display }: Props) {
  const { isEnabled: isPortsControlEnabled } = useFeatureFlag('portsControl');
  const { isEnabled: areControlsEnabled } = useFeatureFlag('controls');
  const isSupported =
    !!display.keyboardControl?.reported ||
    !!display.infraRedControl?.reported ||
    !!display.portsControl?.reported;
  return (
    <GridItem colSpan={{ base: 8, md: 7 }}>
      {isSupported ? (
        <Stack direction="column" spacing="10">
          {areControlsEnabled && (
            <Stack direction="column" spacing="10">
              <DisplayInfraRedControlToggle display={display} />
              <DisplayKeyboardControlToggle display={display} />
            </Stack>
          )}
          {isPortsControlEnabled && <DisplayPortsControlToggle display={display} />}
        </Stack>
      ) : (
        <>Locking is not supported for this device.</>
      )}
    </GridItem>
  );
}

DisplayLockingSection.graphql = {
  fragments: {
    DisplayLockingSection_display: gql`
      fragment DisplayLockingSection_display on Display {
        id
        ...DisplayInfraRedControlToggle_display
        ...DisplayKeyboardControlToggle_display
        ...DisplayPortsControlToggle_display
      }
    `,
  },
};
